import {ReactElement, useEffect, useState} from "react";
import {Field, Input, Label, Range} from "@zendeskgarden/react-forms";
import {Tooltip} from "@zendeskgarden/react-tooltips";
import {IoHelpCircleOutline} from "react-icons/io5";
import * as css from "../styles/metric-controls.module.scss";


interface IMetricSliderProps {
    rate: number;
    title: string;
    isRenewals?: boolean;
    onChange: (rate: number) => void;
}

export default function MetricSlider({rate, title, isRenewals = false, onChange}: IMetricSliderProps): ReactElement {
    const [value, setValue] = useState<number>(rate);
    const [inputValue, setInputValue] = useState<number>(rate);

    useEffect(() => {
        setValue(+rate.toFixed(1));
        setInputValue(+rate.toFixed(1));
    }, [rate]);

    return (
        <div className={`${css.metricControls} ${css.metricSlider}`}>
            <div className={css.header}>
                <div className={css.headerLeft}>
                    <h5 className={css.label}>Target Average {title} Rate</h5>
                    {isRenewals &&
                        <div className={css.hintText}>
                            <Tooltip
                                className={css.tooltip}
                                size="medium"
                                placement="end"
                                content="Renewals and Move Outs must total 100%"
                                zIndex={1}
                            >
                                <div>
                                    <IoHelpCircleOutline className={css.hintIcon} /> Target Average Move Out Rate {(100 - value).toFixed(1)}%
                                </div>
                            </Tooltip>
                        </div>
                    }
                </div>
                <Field className={`${css.inputField}`}>
                    <Label hidden>Target Average {title} Rate</Label>
                    <Input
                        value={inputValue}
                        type="number"
                        onChange={(evt) => {
                            let adjustedVal = Number(evt.target.value);

                            if (adjustedVal > 100) {
                                adjustedVal = 100;
                            } else if (adjustedVal < 0) {
                                adjustedVal = 0;
                            }

                            setInputValue(adjustedVal);
                            setValue(adjustedVal);
                            onChange(adjustedVal);
                        }}
                        aria-label={`${title} text entry field`}
                    />
                </Field>
            </div>

            <Field>
                <Label hidden>Target Average {title} Rate</Label>
                <Range
                    value={value}
                    step={.1}
                    type="number"
                    onChange={(evt) => {
                        setValue(Number(evt.target.value));
                        setInputValue(Number(evt.target.value));
                        onChange(Number(evt.target.value));
                    }}
                    aria-label={`${title} range slider`}
                />
            </Field>
        </div>
    );
}
